export default "__VITE_PUBLIC_ASSET__5dd370a3__"